<template>
  <div class="row mb-3">
    <div class="col-4 p-1">
      <UploadFilesSelector
        class="w-100 h-100"
        folder-input-container-class="col-12 col-lg-6 col-xl-12 col-xxl-6 p-1"
        file-input-container-class="col-12 col-lg-6 col-xl-12 col-xxl-6 p-1"
        @add-files="onFilesAdded"
      />
    </div>
    <div class="col-4 p-1">
      <UploadCctvExportSelector
        class="w-100 h-100"
        folder-input-container-class="col-12 col-lg-6 col-xl-12 col-xxl-6 p-1"
        file-input-container-class="col-12 col-lg-6 col-xl-12 col-xxl-6 p-1"
        @add-files="onFilesAdded"
        @add-folders="onFoldersAdded"
      />
    </div>
    <div class="col-4 p-1">
      <UploadZipSelector
        class="w-100 h-100"
        folder-input-container-class="col-12 col-lg-6 col-xl-12 col-xxl-6 p-1"
        file-input-container-class="col-12 col-lg-6 col-xl-12 col-xxl-6 p-1"
        @add-files="onFilesAdded"
        @add-folders="onFoldersAdded"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import UploadFilesSelector from '@/VueComponents/FileUploadSelector/UploadFilesSelector';
  import UploadCctvExportSelector from '@/VueComponents/FileUploadSelector/UploadCctvExportSelector';
  import UploadZipSelector from '@/VueComponents/FileUploadSelector/UploadZipSelector';
  import UploadSelectorFileUploadModel from '@/VueComponents/FileUploadSelector/models/uploadSelectorFileUploadModel';
  import UploadSelectorFolderUploadModel from '@/VueComponents/FileUploadSelector/models/uploadSelectorFolderUploadModel';

  const emit = defineEmits<{
    addFiles: [files: UploadSelectorFileUploadModel[]],
    addFolders: [folders: UploadSelectorFolderUploadModel[]]
  }>();

  function onFilesAdded(files: UploadSelectorFileUploadModel[]) {
    emit('addFiles', files);
  }

  function onFoldersAdded(folders: UploadSelectorFolderUploadModel[]) {
    emit('addFolders', folders);
  }
</script>
